// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect } from 'react';

import Form from '@cloudscape-design/components/form';


import { useGlobalState } from '../../../context/GlobalStateContext'

export const UserLogoffPage = () => {

    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { propiedad, setPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState();
    setIdPropiedad(0)
    setPropiedad('LlaveMovil.com')
    setJWT('')

    useEffect(() => {
        window.location.href = "#user/login"
    }, [setJWT]);
    
    return (
        <Form></Form>
    );

};
